import { Injectable, OnInit } from '@angular/core';
import { Scoring, ScoringParams } from 'ri-api-client';
import { ApiService } from '../api.service';
import { RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ScoringsService {
  public scorings: Scoring.Scoring[];
  public scoreLevels: ScoringParams.ScoringParams[];

  public multiplePatterns: ScoringParams.ScoringParams[] = [
    { name: 'Multipattern', color: '#71C6ED' },
    { name: 'Multipattern', color: '#A4ED84' },
    { name: 'Multipattern', color: '#F2DC6F' },
    { name: 'Multipattern', color: '#E58080' }
  ];

  private fields = '';
  private options: any;
  private scoringMultiplePatterns: ScoringParams.ScoringParams = { color: '#8F8F8F', name: 'MULTIPLE_PATTERNS_ABBR' };

  constructor(private apiService: ApiService) {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    this.options = new RequestOptions({ headers: headers });
    this.apiService.init();
  }

  getScorings(): Observable<any> {
    return this.apiService.client.scorings.GET(this.fields, this.options)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getScoringLevels(): Observable<any> {
    return this.apiService.client.scoringsParams.GET(this.fields, this.options)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getScoringLevelByValue(scoringId, scoreValue, scoreLevels): ScoringParams.ScoringParams {
    if (!scoringId) {
      return null;
    } else if (scoreLevels) {
      if (scoreValue && Array.isArray(scoreValue) && scoreValue.length > 1) {
        return scoreLevels.find(e => e.multipleParams);
      } else {
        if (scoreValue !== null && scoreValue !== undefined) {
          return scoreLevels.find(e => e.idScoring === scoringId && scoreValue >= e.beginLimit && scoreValue <= e.endLimit);
        } else {
          return scoreLevels.find(e => e.idScoring === scoringId && (!e.hasOwnProperty('beginLimit') || !e.hasOwnProperty('endLimit')));
        }
      }
    } else {
      return null;
    }
  }

  getScoreValues(markerData, selectedScoring) {
    let scoreValue: any;
    if (selectedScoring) {
      if (selectedScoring.scoringModelClass !== 'ucs') {
        if (markerData[selectedScoring.scoringModelClass] && markerData[selectedScoring.scoringModelClass].length > 0) {
          if (markerData[selectedScoring.scoringModelClass] && markerData[selectedScoring.scoringModelClass].length > 1) {
            scoreValue = [];
            markerData[selectedScoring.scoringModelClass].forEach(element => {
              scoreValue.push(element[selectedScoring.scoringModelProperty]);
            });
          } else {
            const propertyArray = markerData[`${selectedScoring.scoringModelClass}`];
            scoreValue = propertyArray && propertyArray[0][selectedScoring.scoringModelProperty] ? propertyArray[0][selectedScoring.scoringModelProperty] : 0;
          }
        } else {
          scoreValue = markerData[`${selectedScoring.scoringModelClass}.${selectedScoring.scoringModelProperty}`];
        }
      } else {
        scoreValue = markerData[selectedScoring.scoringModelProperty];
      }
    }
    return scoreValue;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/api/scorings.service.ts